var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSignals = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2ZM14.81 6.76A5.7 5.7 0 0 1 14.81 15.24L13.68 13.97A4.0 4.0 0 0 0 13.68 8.03ZM7.19 6.76A5.7 5.7 0 0 0 7.19 15.24L8.32 13.97A4.0 4.0 0 0 1 8.32 8.03ZM18.13 4.58A9.6 9.6 0 0 1 18.13 17.42L16.87 16.29A7.9 7.9 0 0 0 16.87 5.71ZM3.87 4.58A9.6 9.6 0 0 0 3.87 17.42L5.13 16.29A7.9 7.9 0 0 1 5.13 5.71Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSignals, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/signals.c2c5338a.svg";
export { ForwardRef as ReactComponent };